<template>
  <div id="app" class="app_main">
    <el-backtop target="" :bottom="58" :right="20">
      <div class="app_back">
        <img src="@/assets/main/back.png" />
        <div>返回顶部</div>
      </div>
    </el-backtop>
    <router-view />
    <footer-box />
    <div class="app_contact_us" @click="clickContactUs">
      <img src="@/assets/main/contact-us.png" />
      <div>联系我们</div>
    </div>
  </div>
</template>
<script>
import FooterBox from "@/components/footer.vue";

export default {
  name: "App",
  components: {
    FooterBox
  },
  methods: {
    clickContactUs() {
      if (this.$route.path !== "/about-us") {
        this.$router.push("/about-us");
      }
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.app_main {
  height: 100%;
  overflow-x: hidden;
}
.el-backtop {
  width: 86px !important;
  height: 92px !important;
}
.app_back {
  padding: 20px 14px 0;
  width: 100%;
  height: 100%;
  background: #fbe74e;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  text-align: center;
  color: #1e241f;
  font-size: 14px;
  border: 1px solid #d9d8d8;
  border-top: none;
}
.app_contact_us {
  cursor: pointer;
  padding: 20px 12px 0;
  width: 86px;
  height: 92px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  background: #ffffff;
  text-align: center;
  color: #1e241f;
  font-size: 14px;
  border: 1px solid #d9d8d8;
  position: fixed;
  right: 20px;
  bottom: 150px;
  border-bottom: none;
  z-index: 999;
}
</style>
